import React from 'react';
import { Input as OriginalInput } from '@fiverr-private/forms';
import { useParentPropsOverrideContext } from '@fiverr-private/ui_utils';

const Input = (props) => {
    const context = useParentPropsOverrideContext();

    return <OriginalInput {...props} {...context} />;
};

export default Input;
